import br from "./br";
import ca from "./ca";
import de from "./de";
import fr from "./fr";
import mx from "./mx";
import nz from "./nz";
import uk from "./uk";
import us from "./us";
import es from "./es";
import eu from "./eu";
import pl from "./pl";
import it from "./it";
import se from "./se";
import au from "./au";
export default {
  br,
  ca,
  de,
  fr,
  mx,
  nz,
  uk,
  us,
  es,
  eu,
  pl,
  it,
  se,
  au,
};
